
const MCLoading = () => <mc-loading />;

export default MCLoading;